import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import { BrandingProvider } from '../../BrandingContext';
import { TemplateProvider, TemplateContext } from '../../templates/TemplateContext';
import './styles/TemplateLayout.css';

const TemplateLayoutContent = () => {
    const template = useContext(TemplateContext);

    const getBackgroundStyle = () => {
        const style = {};
        
        if (template.backgroundType === 'solid') {
            style.backgroundColor = template.backgroundColor;
        } else if (template.backgroundType === 'gradient') {
            style.background = template.backgroundColor;
        } else if (template.backgroundType === 'image' && template.backgroundImage) {
            style.backgroundImage = `url(${template.backgroundImage})`;
            style.backgroundSize = 'cover';
            style.backgroundPosition = 'center';
            style.backgroundRepeat = 'no-repeat';
        }
        
        return style;
    };

    const getSurveyContainerStyle = () => {
        const style = {
            color: template.textColor,
        };

        // Only apply max-width if specified in template
        if (template.surveyMaxWidth && template.surveyMaxWidth !== 'none') {
            style.maxWidth = template.surveyMaxWidth;
        }

        if (template.surveyBackground !== 'transparent') {
            style.backgroundColor = template.surveyBackground;
        }

        if (template.surveyBorder === 'glass') {
            style.backdropFilter = 'blur(15px)';
            style.border = `${template.borderWidth}px solid ${template.borderColor}`;
            style.borderRadius = '16px';
        } else if (template.surveyBorder === 'rounded') {
            style.borderRadius = '12px';
            style.border = `${template.borderWidth}px solid ${template.borderColor}`;
        } else if (template.surveyBorder === 'solid' && template.borderWidth > 0) {
            style.border = `${template.borderWidth}px solid ${template.borderColor}`;
        }

        return style;
    };

    const getLayoutClass = () => {
        let className = 'template-layout';
        
        if (template.surveyPosition === 'overlay') {
            className += ' overlay-layout';
        } else if (template.surveyPosition === 'bottom') {
            className += ' bottom-layout';
        } else {
            className += ' center-layout';
        }
        
        return className;
    };

    return (
        <div className={getLayoutClass()} style={getBackgroundStyle()}>
            {/* Custom CSS injection */}
            {template.customCSS && (
                <style dangerouslySetInnerHTML={{ __html: template.customCSS }} />
            )}
            
            <div className="template-header">
                <Header />
            </div>
            
            <main className="template-content">
                <div 
                    className="survey-container" 
                    style={getSurveyContainerStyle()}
                >
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

const TemplateLayout = () => {
    return (
        <BrandingProvider>
            <TemplateProvider>
                <TemplateLayoutContent />
            </TemplateProvider>
        </BrandingProvider>
    );
};

export default TemplateLayout;
